import { makeStyles } from '@material-ui/core/styles';
import MuiAlert from '@material-ui/lab/Alert';
import React from 'react';

const useStyles = makeStyles(theme => ({
  icon: { padding: '9px 0' },
  message: theme.typography.body,
}));

type MuiProps = React.ComponentProps<typeof MuiAlert>;

export type AlertProps = Omit<MuiProps, 'color'>;

export const Alert: React.VFC<AlertProps> = ({ classes, ...rest }) => {
  const overrideClasses = useStyles();
  return (
    <MuiAlert
      {...rest}
      classes={{ ...(classes ?? null), ...overrideClasses }}
    />
  );
};
